import *  as axios from 'axios';
import * as PaymentActionTypes from '../../constants/actiontypes/backoffice/payments';
import * as paymentUrl from '../../constants/webapi/backoffice/payments';
import { getAuthenticationUrl } from '../../constants/webapi/auth';




// get Clients invoices
export function fetchClientsInvoices(pageNumber, searchTerm, status, startDate, endDate, sortByTerm, sortDesc) {
    pageNumber -= 1;

    return (dispatch) => {
        dispatch({ type: PaymentActionTypes.FETCH_CLIENTS_INVOICES_REQUEST });
        return axios.get(paymentUrl.clientsInvoicesUrl(pageNumber, searchTerm, status, startDate, endDate, sortByTerm, sortDesc))
            .then((response) => {
                dispatch({
                    type: PaymentActionTypes.FETCH_CLIENTS_INVOICES_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {

                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: PaymentActionTypes.FETCH_CLIENTS_INVOICES_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

// export function fetchAllClientsInvoices() {
//     return (dispatch) => {
//         dispatch({ type: PaymentActionTypes.FETCH_ALL_CLIENTS_INVOICES_REQUEST });
//         return axios.get(paymentUrl.allClientsInvoicesUrl())
//             .then((response) => {
//                 dispatch({
//                     type: PaymentActionTypes.FETCH_ALL_CLIENTS_INVOICES_SUCCESS,
//                     data: response.data
//                 });
//             })
//             .catch((error) => {

//                 if (error.response !== undefined && error.response.status === 401) {
//                     window.location = getAuthenticationUrl();
//                     return;
//                 }
//                 dispatch({
//                     type: PaymentActionTypes.FETCH_ALL_CLIENTS_INVOICES_FAILURE,
//                     response: error.response
//                 });
//                 throw error.statusText;
//             });
//     };
// }
export function fetchAllClientsInvoices() {

    return new Promise((resolve, reject) => {
        axios.get(paymentUrl.allClientsInvoicesUrl())
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }

                throw error.statusText;
            });
    });

}

export function fetchPartnersInvoices(pageNumber, searchTerm, status, startDate, endDate, sortByTerm, sortDesc) {

    pageNumber -= 1;

    return (dispatch) => {
        dispatch({ type: PaymentActionTypes.FETCH_PARTNERS_INVOICES_REQUEST });
        return axios.get(paymentUrl.partnersInvoicesUrl(pageNumber, searchTerm, status, startDate, endDate, sortByTerm, sortDesc))
            .then((response) => {
                dispatch({
                    type: PaymentActionTypes.FETCH_PARTNERS_INVOICES_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {

                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: PaymentActionTypes.FETCH_PARTNERS_INVOICES_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

// export function fetchaAllPartnersInvoices() {
//     return (dispatch) => {
//         dispatch({ type: PaymentActionTypes.FETCH_ALL_PARTNERS_INVOICES_REQUEST });
//         return axios.get(paymentUrl.allPartnersInvoicesUrl())
//             .then((response) => {
//                 dispatch({
//                     type: PaymentActionTypes.FETCH_ALL_PARTNERS_INVOICES_SUCCESS,
//                     data: response.data
//                 });
//             })
//             .catch((error) => {

//                 if (error.response !== undefined && error.response.status === 401) {
//                     window.location = getAuthenticationUrl();
//                     return;
//                 }
//                 dispatch({
//                     type: PaymentActionTypes.FETCH_ALL_PARTNERS_INVOICES_FAILURE,
//                     response: error.response
//                 });
//                 throw error.statusText;
//             });
//     };
// }
export function fetchaAllPartnersInvoices() {

    return new Promise((resolve, reject) => {
        axios.get(paymentUrl.allPartnersInvoicesUrl())
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }

                throw error.statusText;
            });
    });
}

export function markPartnersInvoicesPaid(partner) {
    return (dispatch) => {
        dispatch({ type: PaymentActionTypes.MARKPAID_PARTNER_INVOICE_REQUEST });
        return axios.put(paymentUrl.markpaidPartnersInvoicesUrl(partner.id), { ...partner })
            .then((response) => {
                dispatch({
                    type: PaymentActionTypes.MARKPAID_PARTNER_INVOICE_SUCCESS,
                    data: response.data,
                    partnerId: partner.id
                });
            })
            .catch((error) => {

                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: PaymentActionTypes.MARKPAID_PARTNER_INVOICE_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function fetchInvoiceLines(invoiceId) {
    return (dispatch) => {
        dispatch({ type: PaymentActionTypes.FETCH_PARTNER_INVOICE_LINES_REQUEST });
        return axios.get(paymentUrl.partnersInvoicesLinesUrl(invoiceId))
            .then((response) => {
                dispatch({
                    type: PaymentActionTypes.FETCH_PARTNER_INVOICE_LINES_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {

                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: PaymentActionTypes.FETCH_PARTNER_INVOICE_LINES_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}